// webpack 5's default asset/resource handling emits this as a hashed static
// file and resolves the import to its final URL - no loader config needed.
// This is "model_2" of the three files in this folder: model_1 is the
// Vuelta Ciclista events' own jersey, model_3 is the Indiana Jones event's -
// this one is the app-wide fallback used whenever a season hasn't uploaded
// its own (see season.jersey_model_url / Panel.vue's season edit modal /
// server.js's upload_season_model).
import default_jersey_model_url from '@/assets/models/model_2.glb'

// The one 3D model every Avatar3DPicker instance renders - configurable per
// season/evento so each event can have its own (a season uploads one via
// the admin panel; see server.js's upload_season_model), instead of a
// single hardcoded asset for the whole app. Follows game.active_season_id -
// whichever season's own join_code a guest last validated (scanning that
// event's QR from Panel.vue's listing - see server.js's validate_join_code),
// defaulting to whichever season was seeded/created first until one is.
export function get_active_jersey_model_url(){
    const game = (window.store && window.store.state.game) || {};
    const seasons = game.seasons || [];
    const season = seasons.find((s) => s.id == game.active_season_id) || seasons[0];
    return (season && season.jersey_model_url) || default_jersey_model_url;
}

export default default_jersey_model_url;
